import React from 'react';
import s from './VisualsAreEverything.module.css';
import fashionImg from './images/fashion.png';
import coffeeImg from './images/coffee.png';
import {
    OptimizedMotionH2,
    OptimizedMotionP,
    OptimizedMotion,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';
import { useNavigate } from 'react-router-dom';

const VisualsAreEverything: React.FC = () => {
    const navigate = useNavigate();
    return (
        <section className={s.container}>
            <div className={s.header}>
                <OptimizedMotionH2 type="slide-up" delay={0.3} className={s.title}>
                    <span className={s.highlight}>Your visuals are everything.</span>
                </OptimizedMotionH2>
                <OptimizedMotionP type="slide-up" delay={0.8} className={s.subtitle}>
                    SimpleeCreate makes them sell.
                </OptimizedMotionP>
            </div>

            <div className={s.section}>
                <div className={s.textBlock}>
                    <OptimizedMotionH2 type="slide-up" delay={0.8} className={s.blockTitle}>
                        Your visuals sell before your words do
                    </OptimizedMotionH2>
                    <OptimizedMotionP type="slide-up" delay={0.9} className={s.text}>
                        You started your business because you believed in your product — not because
                        you wanted to spend hours editing photos, fixing lighting, or guessing what
                        looks "on-brand."
                    </OptimizedMotionP>
                    <OptimizedMotionP type="slide-up" delay={1.1} className={s.text}>
                        But in today's world, your visuals are your storefront. They decide if
                        customers stop, click, and buy — or scroll past.
                    </OptimizedMotionP>
                    <OptimizedMotionP type="slide-up" delay={1.2} className={s.text}>
                        You've tried DIY tools, freelancers, or agencies, but they're either
                        time-consuming, expensive, or inconsistent. It's frustrating when your
                        product deserves more than generic templates.
                    </OptimizedMotionP>
                    <OptimizedMotion
                        type="slide-up"
                        delay={1.3}
                        className={s.cta}
                        onClick={() => navigate('/contact')}
                    >
                        Request Access
                    </OptimizedMotion>
                </div>

                <div className={s.imageBlock}>
                    <img src={fashionImg} alt="Models" className={s.image} />
                </div>
            </div>

            <div className={`${s.section} ${s.reverse}`}>
                <div className={s.textBlock}>
                    <OptimizedMotionH2 type="slide-up" delay={0.3} className={s.blockTitle}>
                        Enter SimpleeCreate.
                    </OptimizedMotionH2>
                    <OptimizedMotionP type="slide-up" delay={0.8} className={s.text}>
                        SimpleeCreate uses AI trained on real brand and design principles. It
                        understands your product, adapts to your brand, and creates visuals that
                        look premium — instantly.
                    </OptimizedMotionP>
                    <OptimizedMotionP type="slide-up" delay={1.0} className={s.text}>
                        The result? Professional, consistent, high-converting images — without
                        wasting time or money. You've done the hard work — building something worth
                        showing. You deserve visuals that reflect that. Let SimpleeCreate do the
                        rest.
                    </OptimizedMotionP>
                    <OptimizedMotion
                        type="slide-up"
                        delay={1.2}
                        className={s.cta}
                        onClick={() => navigate('/contact')}
                    >
                        Request Access
                    </OptimizedMotion>
                </div>

                <div className={s.imageBlock}>
                    <img src={coffeeImg} alt="Coffee cup" className={s.image} />
                </div>
            </div>
        </section>
    );
};

export default VisualsAreEverything;
